export enum ButtonStyle {
  TRANSPARENT = 'transparent',
  SECONDARY_TRANSPARENT = 'secondary_transparent',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  ALERT = 'alert',
}

export enum RedesignButtonStyle {
  PLUM = 'plum',
  DARK_GREEN = 'dark green',
  TRANSPARENT = 'transparent',
  WHITE_WITH_PLUM_FONT = 'white with plum font',
  WHITE_WITH_GREEN_FONT = 'white with green font',
}

export enum RedesignMeridianButtonStyle {
  ORANGE = 'orange',
  TRANSPARENT_WITH_WHITE_FONT_AND_BORDER = 'transparent with white font and border',
  TRANSPARENT_WITH_BLUE_FONT_AND_BORDER = 'transparent with blue font and border',
  WITHOUT_BORDERS_WITH_WHITE_FONT = 'without borders with white font',
  WITHOUT_BORDERS_WITH_BLUE_FONT = 'without borders with blue font',
}

export enum ButtonsArrangement {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}
